// مودالِ تأییدِ جدی برای عملیاتِ برگشت‌ناپذیر (بازیابی / بروزرسانی).
// دو دروازه: پینِ مدیر + تایپِ دستیِ کلمهٔ تأیید — هیچ‌کدام به‌تنهایی کافی نیست.
import React, { useEffect, useState } from "react";
import { Input, List, Modal, Space, Typography } from "antd";
import Alert from "../../../components/GxAlert";

const { Text } = Typography;

export default function DangerConfirmModal({
  open, title, word = "بازیابی", checklist = [], warning, okText = "تأیید و اجرا",
  confirmLoading, onCancel, onConfirm,
}) {
  const [pin, setPin] = useState("");
  const [typed, setTyped] = useState("");

  useEffect(() => {
    if (open) { setPin(""); setTyped(""); }
  }, [open]);

  const ready = pin.trim().length > 0 && typed.trim() === word;

  return (
    <Modal
      open={open} title={title} onCancel={onCancel} destroyOnHidden
      okText={okText} cancelText="انصراف"
      okButtonProps={{ danger: true, disabled: !ready }}
      confirmLoading={confirmLoading}
      onOk={() => onConfirm({ admin_pin: pin.trim(), confirm_text: typed.trim() })}
    >
      <div style={{ direction: "rtl" }}>
        {warning && <Alert type="warning" showIcon message={warning} style={{ marginBottom: 12 }} />}
        {checklist.length > 0 && (
          <List size="small" bordered style={{ marginBottom: 12 }}
            header={<Text strong>چه اتفاقی می‌افتد:</Text>}
            dataSource={checklist}
            renderItem={(item) => <List.Item>{item}</List.Item>} />
        )}
        <Space direction="vertical" style={{ width: "100%" }}>
          <div>
            <Text type="secondary" style={{ fontSize: 12 }}>پینِ مدیریتی</Text>
            <Input.Password value={pin} onChange={(e) => setPin(e.target.value)}
              placeholder="پینِ مدیریتی" autoComplete="off" />
          </div>
          <div>
            <Text type="secondary" style={{ fontSize: 12 }}>
              برای تأیید، کلمهٔ «{word}» را تایپ کنید
            </Text>
            <Input value={typed} onChange={(e) => setTyped(e.target.value)} placeholder={word} />
          </div>
        </Space>
      </div>
    </Modal>
  );
}
